import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useAppSelector, useAppDispatch } from '../hooks';
import { Link } from 'react-router-dom';
import { getManufacturerName } from '../types/Zigbee/NodeDescriptor';
import { fetchZigbeeNode } from '../actions/FetchZigbeeNode';
import { permitJoining } from '../actions/PermitJoining';
export const ConfigZigbee = () => {
    const [nwkId, setNwkId] = React.useState('');
    const zigbee_nodes = useAppSelector(state => state.definitions.zigbee_nodes);
    const zigbee_node_descriptors = useAppSelector(state => state.definitions.zigbee_node_descriptors);
    const dispatch = useAppDispatch();
    const onChange = event => {
        setNwkId(event.target.value);
    };
    const onSubmit = event => {
        event.preventDefault();
        dispatch(fetchZigbeeNode(nwkId));
    };
    const onPermitJoining = event => {
        event.preventDefault();
        dispatch(permitJoining());
    };
    const rows = [];
    const nodes = Array.from(Object.values(zigbee_nodes));
    if (nodes) {
        nodes.sort((a, b) => { var _a, _b, _c, _d, _e, _f; if (((_a = a.nwk) !== null && _a !== void 0 ? _a : 0) == ((_b = b.nwk) !== null && _b !== void 0 ? _b : 0)) {
            return ((_c = a.ieee) !== null && _c !== void 0 ? _c : 0) - ((_d = b.ieee) !== null && _d !== void 0 ? _d : 0);
        }
        else {
            return ((_e = a.nwk) !== null && _e !== void 0 ? _e : 0) - ((_f = b.nwk) !== null && _f !== void 0 ? _f : 0);
        } });
        for (const node of nodes) {
            const nwk = node.nwk == null ? '?' : ('0x' + node.nwk.toString(16).padStart(4, '0'));
            const ieee = node.ieee_hex != null ? ('0x' + node.ieee_hex) : (node.ieee == null ? null : ('0x' + node.ieee.toString(16).padStart(16, '0')));
            const node_descriptor = zigbee_node_descriptors[node.id];
            const manufacturer = getManufacturerName(node_descriptor);
            const zigbee_device_link = _jsx(Link, { to: '/config/zigbee/' + node.id, children: _jsxs("span", { style: { color: 'green' }, children: [" ", nwk] }) });
            const last_seen = new Date(node.last_seen).toLocaleString();
            rows.push(_jsxs("tr", { children: [_jsx("td", { children: zigbee_device_link }), _jsx("td", { children: ieee }), _jsx("td", { children: manufacturer }), _jsx("td", { children: node.title }), _jsx("td", { children: last_seen })] }, node.id));
        }
    }
    return (_jsxs("div", { className: "page-container", children: [_jsx("h1", { children: "Zigbee" }), _jsxs("table", { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "NWK" }), _jsx("th", { children: "IEEE" }), _jsx("th", { children: "Manufacturer" }), _jsx("th", { children: "Name" }), _jsx("th", { children: "Last seen" })] }) }), _jsx("tbody", { children: rows })] }), _jsxs("form", { onSubmit: onSubmit, style: { padding: '10px 10px', borderTop: '3px solid #ddd' }, children: ["Get device info for NWK id: ", _jsx("input", { type: "text", value: nwkId, onChange: onChange }), " ", _jsx("button", { type: "submit", children: "H\u00E4mta" })] }), _jsx("form", { onSubmit: onPermitJoining, style: { padding: '10px 10px', borderTop: '3px solid #ddd' }, children: _jsx("button", { type: "submit", children: "Permit joining for 2 minutes" }) })] }));
};
